<template><Footer /></template>
<script>
import Footer from "../Home/Footer.vue";
export default { name: "SiteFooter", components: { Footer } };
</script>
